import store from "store";
import {
  ANALYTICS_FILTERS,
  ANALYTICS_ACCOUNTS_DATA,
  CONTACT_ANALYTICS,
  CONTENT_ANALYTICS,
  ANALYTICS_ACCOUNTS_DASHBOARD,
  ANALYTICS_CARD_DATA,
  ANALYTICS_DASHBOARD_GRAPH_DATA,
  ANALYTICS_INTENT_DATA,
  ANALYTICS_DASHBOARD,
  ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS,
  ANALYTICS_EMAIL_TRENDS,
  ANALYTICS_CLICK_TRENDS,
} from "constants/types/analyticsTypes";
import { removeCampaignAndEmailQueryParams } from "utils";
import { getAnalyticsFilterService, saveAnalyticsFilterService } from "modules/Services/AnalyticsService";
import { getAnalyticsFilterId } from "modules/EmailBrowser/utils";
import {
  reorderCampaignsAndEmails,
  resetDashboardCampaignFilters,
  selectAllCampaigns,
  selectAsset,
  selectCampaign,
  selectWorkflowAsset,
  setCampaignsFilter,
  setDailyIqFilter,
  setDefaultWorkflow,
  setShareProfileFilter,
  setWeeklyAccountInsightsFilter,
  setWorkflowAssetsFilter,
  toggleWorkflowFilter,
  unselectAllWorkflowEmails,
} from "./Dashboard/actions";

export const filterButtonPressed = (isFilterClicked: boolean, history: History) => {
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DATA.RESET,
  });
  store.dispatch({
    type: CONTACT_ANALYTICS.RESET_ALL,
  });
  store.dispatch({
    type: CONTENT_ANALYTICS.RESET,
  });
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DASHBOARD.RESET,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.CLEAR,
  });
  store.dispatch({
    type: ANALYTICS_CARD_DATA.RESET,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.RESET,
  });
  if (isFilterClicked) {
    store.dispatch({
      type: ANALYTICS_FILTERS.APPLY,
    });
    saveFiltersOnClick(history);
  }

  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.SET,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
  });
  store.dispatch({
    type: ANALYTICS_INTENT_DATA.EXPORT_LOAD,
    payload: true,
  });
  store.dispatch({
    type: ANALYTICS_EMAIL_TRENDS.RESET,
  });
  store.dispatch({
    type: ANALYTICS_CLICK_TRENDS.RESET,
  });
  removeCampaignAndEmailQueryParams();
};

export const moveSelectedFiltersToApplied = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.SET,
  });
};
export const moveAppliedFiltersToSelected = () => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD_SET_APPLIED_CAMPAIGNS_ASSETS.UNSET,
  });
};

export const filterButtonPressReset = () => {
  store.dispatch({
    type: ANALYTICS_FILTERS.RESET,
  });
};

export const resetRedirectUrls = () => {
  store.dispatch({
    type: ANALYTICS_ACCOUNTS_DATA.RESET_REDIRECT_URL,
  });
  store.dispatch({
    type: CONTACT_ANALYTICS.RESET_REDIRECT_URL,
  });
};

export const updateCampaignLimit = (value: boolean) => {
  store.dispatch({
    type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_LIMIT,
    payload: value,
  });
};

const saveFiltersOnClick = (history: History) => {
  const storeState = store.getState();
  const selectedCampaignIds = storeState.analyticsDashboard.selectedCampaignsIds;
  const excludeCampaignIds = storeState.analyticsDashboard.excludeCampaignsIds;
  const selectedEmailsIds = storeState.analyticsDashboard.selectedAssetsIds;
  const excludeEmailsIds = storeState.analyticsDashboard.excludeAssetsIds;
  const selectedWorkflowsIds = storeState.analyticsDashboard.selectedWorkflowsIds;
  const isAllCampaigns = storeState.analyticsDashboard.campaignsFilters.isAllCampaigns;
  const isWorkflow = storeState.analyticsDashboard.isWorkflow;
  const isShareProfile = storeState.analyticsDashboard.isShareProfile;
  const isDailyIQ = storeState.analyticsDashboard.isDailyIQ;
  const isWeeklyAccountInsights = storeState.analyticsDashboard.isWeeklyAccountInsights;
  const startDate = storeState.analyticsGraph.startDate;
  const endDate = storeState.analyticsGraph.endDate;
  const appliedDateObject = storeState.analyticsGraph.selectedDatesObject;
  let campaign_ids = [];
  let email_ids = [];
  if (isShareProfile) {
    campaign_ids = ["1"];
    email_ids = ["1"];
  } else if (isDailyIQ) {
    campaign_ids = ["2"];
    email_ids = ["2"];
  } else if (isWeeklyAccountInsights) {
    campaign_ids = ["3"];
    email_ids = ["3"];
  } else if (isAllCampaigns) {
    campaign_ids = [];
    email_ids = [];
  } else {
    campaign_ids = selectedCampaignIds;
    email_ids = selectedEmailsIds;
  }
  const params: any = {
    start_date: startDate,
    end_date: endDate,
    is_workflow: isWorkflow,
    all_campaigns: isAllCampaigns,
    daily_IQ: isDailyIQ,
    share_profile: isShareProfile,
    weekly_account_insights: isWeeklyAccountInsights,
    campaign_ids: campaign_ids,
    email_ids: email_ids,
    workflow_ids: selectedWorkflowsIds,
    exclude_campaign_ids: excludeCampaignIds,
    exclude_email_ids: excludeEmailsIds,
    applied_date_object: appliedDateObject,
  };
  saveAnalyticsFilterService(JSON.stringify(params)).then((response) => {
    const newParam = response.data.id;
    const urlSearchParams = new URLSearchParams(window.location.search);
    urlSearchParams.set("fs_id", newParam);
    const newUrl = `${window.location.pathname}?${urlSearchParams.toString()}`;
    history.replace(newUrl);
  });
};

export const applyFilterUsingFilterId = () => {
  const fsId = getAnalyticsFilterId();
  getAnalyticsFilterService(fsId).then((response) => {
    // saving the response in local storage to use once campaigns, emails and workflows are loaded
    localStorage.setItem("analyticsFiltersWithId", JSON.stringify(response.data));
    //applyFiltersFromLocalStorage(response.data);
  });
};

export const applyFiltersFromLocalStorage = (data: any) => {
  const analyticsDashboard = store.getState().analyticsDashboard;
  const campaigns = analyticsDashboard.campaigns;
  const assets = analyticsDashboard.assets;
  const filters = data?.saved_data;
  if (filters.share_profile) {
    setShareProfileFilter(true);
    store.dispatch({
      type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
    });
  }
  if (filters.daily_IQ) {
    setDailyIqFilter(true);
    store.dispatch({
      type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
    });
  }
  if (filters.weekly_account_insights) {
    setWeeklyAccountInsightsFilter(true);
    store.dispatch({
      type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
    });
  }
  if (filters.all_campaigns) {
    resetDashboardCampaignFilters();
    // to avoid the reset calling in the setCampaignsFilter function
    setCampaignsFilter({ isAllCampaigns: true }, true);
    selectAllCampaigns();
    store.dispatch({
      type: ANALYTICS_DASHBOARD.SET_CAMPAIGN_FILTERS,
    });
    if (filters.exclude_campaign_ids) {
      filters.exclude_campaign_ids.forEach((campaignId: any) => {
        selectCampaign(campaignId, campaigns);
      });
    }
    if (filters.exclude_email_ids) {
      let filterAssets = assets;
      filterAssets.forEach((filterAsset: any) => {
        if (filters.exclude_email_ids.includes(filterAsset.id)) {
          selectAsset(filterAsset.id, filterAsset.campaignId);
        }
      });
    }
  }
  if (filters.campaign_ids) {
    let campaignEmails = [];
    if (filters.campaign_ids.length === 1) {
      campaignEmails = filters.campaign_ids.map((id: number) => {
        if (["1", "2", "3"].includes(id.toString())) {
          return [];
        }
        selectCampaign(id);
        return assets.filter((asset: any) => asset.campaignId === id);
      });
    } else {
      campaignEmails = filters.campaign_ids.map((id: number) => {
        selectCampaign(id);
        return assets.filter((asset: any) => asset.campaignId === id);
      });
    }
    campaignEmails = campaignEmails?.flatMap((obj: any) => Object.values(obj));
    campaignEmails = campaignEmails?.filter((obj: any) => !filters.email_ids.includes(obj.id));
    campaignEmails?.forEach((asset: any) => {
      selectAsset(asset.id, asset.campaignId);
    });
  }
  if (filters.is_workflow) {
    toggleWorkflowFilter(true);
    if (filters.workflow_ids) {
      setWorkflowAssetsFilter({ isAllType: true });
      setDefaultWorkflow(filters.workflow_ids[0]);
    }
    if (filters.email_ids) {
      unselectAllWorkflowEmails();
      filters.email_ids.forEach((emailId: any) => {
        selectWorkflowAsset(emailId, filters.workflow_ids[0]);
      });
    }
  }
  moveSelectedFiltersToApplied();
  store.dispatch({ type: ANALYTICS_DASHBOARD_GRAPH_DATA.RESET_DATES });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES_OBJECT,
    payload: filters.applied_date_object,
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES_OBJECT,
    payload: filters.applied_date_object,
  });
  const start_date = filters.start_date;
  const end_date = filters.end_date;
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_DATES,
    ...{ start_date, end_date },
  });
  store.dispatch({
    type: ANALYTICS_DASHBOARD_GRAPH_DATA.SET_APPLIED_DATES,
    ...{ start_date, end_date },
  });
  reorderCampaignsAndEmails();
};
